<template>
    <div>

        <div class="sifarnik-top-line">
            <div class="sifarnik-top-left">
                <RouteTab current_tab="Sifarnik" />
            </div>
            <div class="sifarnik-top-right">
                <CustomDropdown style="margin-right:2rem;" :id="'drop_sifarnik_type'" v-model="sifra_type"
                    :drop_items="drop_items" />


                <div class="upload-stavke-button upload-dokumenta-button " @click="openPopNew()">
                    Unesi novu šifru
                    <div class="upload-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                            <g>
                                <g>
                                    <path fill="#fff"
                                        d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z" />
                                </g>
                            </g>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="open-folder-line-left switch-sudionici-wrapp right">
            <label class="bigger-switch">
                <input type="checkbox" v-model="is_editable_sort">
                <span class="slider round"></span>

            </label>
            <span class="status-switch">{{ edit_status }}</span>

        </div>
        <div class="sifarnik-main-wrapper">
            <div class="sifarnik-item-wrapper">
                <draggable :sort="is_editable_sort" v-model="sifre">
                    <div class="sifarnik-item" v-for="(sifra, key) in sifre" :key="key"
                        :id="'sifra-' + sifra_type + '-' + sifra.id">
                        <div class="sifarnik-item-left">
                            <div class="edit-menu">
                                <input type="checkbox" />
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div class="sifarnik-item-no">{{ key + 1 }}</div>
                            <div class="sifarnik-item-title">{{ sifra.naziv }}</div>
                        </div>
                        <div class="sifarnik-item-right sifarnik-edit-hidden">
                            <div class="sifarnik-edit add-button add-pen"
                                @click="selectSifra(('#sifra-' + sifra_type + '-' + sifra.id), sifra)"><svg
                                    xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                                    <g>
                                        <g>
                                            <path fill="#7b7b8a"
                                                d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z" />
                                        </g>
                                    </g>
                                </svg></div>
                            <div class="sifarnik-delete" @click="popDeleteView(sifra)"><svg
                                    xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15">
                                    <g>
                                        <g>
                                            <path fill="#7b7b8a"
                                                d="M11.934 3.295v.918a.459.459 0 0 1-.459.46H.46A.459.459 0 0 1 0 4.212v-.918c0-.634.514-1.147 1.148-1.147h2.524v-.46c0-.76.617-1.376 1.377-1.376h1.836c.76 0 1.377.616 1.377 1.377v.459h2.525c.633 0 1.147.513 1.147 1.147zM4.59 2.148h2.754v-.46a.46.46 0 0 0-.459-.458H5.05a.46.46 0 0 0-.459.459zm6.473 3.442c.082 0 .147.069.144.15l-.38 7.948A1.375 1.375 0 0 1 9.453 15h-6.97c-.736 0-1.34-.576-1.375-1.312l-.38-7.947a.143.143 0 0 1 .144-.15zm-3.26 7.115a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0zm-2.295 0a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0zm-2.295 0a.459.459 0 1 0 .918 0V6.738a.459.459 0 1 0-.918 0z" />
                                        </g>
                                    </g>
                                </svg></div>
                        </div>
                    </div>
                </draggable>
            </div>
        </div>
        <v-dialog v-model="renameSifraPop" width="564px">
            <v-card color="universal-vcard">
                <div class="universal-vdialog-title">
                    {{ pop_text }}
                </div>
                <v-text-field class="universal-vdialog-textfield" label="Naziv šifre za prikaz"
                    v-model="create_edit_sifra"></v-text-field>
                <div class="vdialog-buttons-wrapper">
                    <div class="universal-vdialog-button vbutton-secondary" @click="renameSifraPop = false"> Odustani
                    </div>
                    <div class="universal-vdialog-button vbutton-primary" @click="editAdd()"> {{ save_btn_txt }}
                    </div>
                </div>
                <v-snackbar v-model="snackbar_pop" color="snack-custom-dark-blue" elevation="24">
                    {{ pop_error_msg }}
                    <template v-slot:action="{ attrs }">
                        <v-btn color="white" text v-bind="attrs" @click="delete_snack_pop = false">
                            U redu
                        </v-btn>
                    </template>
                </v-snackbar>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteSifraPop" width="564px">
            <v-card color="universal-vcard">
                <div class="universal-vdialog-title">
                    Jeste li sigurni da želite pobrisati šifru?
                </div>
                <div class="vdialog-buttons-wrapper">
                    <div class="universal-vdialog-button vbutton-secondary" @click="deleteSifraPop = false"> Odustani
                    </div>
                    <div class="universal-vdialog-button vbutton-error" @click="deleteCode()"> Potvrdi
                    </div>
                </div>
                <v-snackbar v-model="delete_snack_pop" color="snack-custom-dark-blue" elevation="24">
                    Nije moguće obrisati šifru jer se već koristi u sustavu!
                    <template v-slot:action="{ attrs }">
                        <v-btn color="white" text v-bind="attrs" @click="delete_snack_pop = false">
                            U redu
                        </v-btn>
                    </template>
                </v-snackbar>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import predmet_hand from "@/apiCallers/promise_handler_db/predmeti";
import $ from "jquery";
import RouteTab from "@/components/sifarnik/RouteTab.vue";
import gsap from "gsap";

import draggable from "vuedraggable";

import CustomDropdown from "@/components/generalComponents/CustomDropdown.vue";

export default {
    components: {
        CustomDropdown,
        RouteTab,
        draggable
    },

    data() {

        return {
            sifre: [],
            deleteSifraPop: false,
            is_editable_sort: false,
            drop_items: [
                { id: 1, naziv: 'Vrsta postupka' },
                { id: 2, naziv: 'Faza postupka' },
                { id: 3, naziv: 'Statusi (protu)stranke' },
                { id: 4, naziv: 'Statusi službenika' },
            ],

            selected_sifra: null,
            sifra_type: null,
            renameSifraPop: false,

            // popup edit create values
            create_edit_sifra: "",
            pop_text: "Uredite naziv",
            edit_pop_text: "Uredite naziv",
            new_pop_text: "Dodajte novu šifru",
            pop_error_msg: "Potrebno je definirati naziv šifre!",
            snackbar_pop: false,
            delete_snack_pop: false,
            save_btn_txt: "Pohrani izmjene"

        };

    },
    watch: {
        is_editable_sort() {
            if (this.is_editable_sort) {
                gsap.to(".edit-menu", 0.5, { paddingRight: "20px", display: "block", opacity: 1 });
                gsap.to(".sifarnik-edit-hidden", 0.5, { paddingRight: "20px", display: "flex", opacity: 1 });
                // gsap.to(".not-editable-sudionici", 0.5, {  opacity: 0.3 });

            }
            else {
                gsap.to(".edit-menu", 0.2, { paddingRight: "0px", opacity: 0, display: "none" });
                gsap.to(".sifarnik-edit-hidden", 0.2, { paddingRight: "0px", opacity: 0, display: "none" });
                // gsap.to(".not-editable-sudionici", 0.5, {  opacity: 1 });
            }
        },
        sifre: function () {
            if (this.is_editable_sort) {
                predmet_hand.updateOrderSifre(this.sifre, this.sifra_type);

            }
        },
        sifra_type: function () {
            $(".sifarnik-item").removeClass("opened-sifarnik");
            this.getData();
        },
        renameSifraPop: function () {
            if (!this.renameSifraPop) {
                $(".sifarnik-item").removeClass("opened-sifarnik");
            }
        }
    },
    computed: {
        edit_status: function () {
            return this.is_editable_sort ? "Uređivanje šifri" : "Pregled šifri";
        }
    },
    methods: {
        popDeleteView: function (sifra_tmp) {
            this.selected_sifra = sifra_tmp;
            this.deleteSifraPop = true;
        },
        refreshSifre(respData) {
            this.sifre = respData;
            this.pop_error_msg = "";
            this.create_edit_sifra = "";
            this.renameSifraPop = false;
            this.deleteSifraPop = false;
            this.delete_snack_pop = false;
        },
        editAdd: function () {
            if (this.selected_sifra != null) {
                this.renameCode();
            } else {
                this.addCode();
            }
        },
        validateName: function () {
            if (this.create_edit_sifra.trim().length === 0) {
                this.pop_error_msg = "Naziv šifre ne smije biti prazan."
                return false;
            } else if (this.sifre.filter((p) => { return p.naziv == this.create_edit_sifra }).length > 0) {
                this.pop_error_msg = "Naziv šifre već postoji u popisu!"
                return false;
            }
            else
                return true;
        },
        selectSifra: function (active_id, selected_sif) {
            this.save_btn_txt = "Pohrani izmjene"
            // opened-sifarnik
            this.pop_text = this.edit_pop_text;
            this.renameSifraPop = true;
            $(".sifarnik-item").removeClass("opened-sifarnik");
            $(active_id).addClass("opened-sifarnik");
            this.selected_sifra = selected_sif;
            this.create_edit_sifra = selected_sif.naziv;
        },
        openPopNew: function () {
            this.save_btn_txt = "Dodaj"
            this.pop_text = this.new_pop_text;
            $(".sifarnik-item").removeClass("opened-sifarnik");
            this.selected_sifra = null;
            this.create_edit_sifra = "";
            this.renameSifraPop = true;
        },



        // GET DATA SWITCH START

        getData: async function () {
            this.is_editable_sort = false;
            switch (this.sifra_type) {
                case 1:
                    await predmet_hand.getAllPostupci().then((resp) => {
                        this.refreshSifre(resp.data.vrste_postupka)
                    })
                    break;
                case 2:
                    await predmet_hand.getAllPhases().then((resp) => {
                        this.refreshSifre(resp.data.faze_postupka)
                    });
                    break;
                case 3:
                    await predmet_hand.getAllOznakeStatus().then((resp) => {
                        this.refreshSifre(resp.data.oznake_status)
                    });
                    break;
                case 4:
                    await predmet_hand.getAllSluzbenaUloga().then((resp) => {
                        this.refreshSifre(resp.data.oznake_status)
                    });
                    break;
            }
        },
        // GET DATA SWITCH END



        // EDIT DATA SWITCH START
        renameCode: async function () {
            let is_valid = this.validateName();
            if (is_valid) {

                switch (this.sifra_type) {
                    case 1:
                        await predmet_hand.updatePostupak(this.create_edit_sifra, this.selected_sifra.id).then((resp) => {
                            this.refreshSifre(resp.data.vrste_postupka)
                        })
                        break;
                    case 2:
                        await predmet_hand.updateFaze(this.create_edit_sifra, this.selected_sifra.id).then((resp) => {
                            this.refreshSifre(resp.data.faze_postupka)
                        })
                        break;
                    case 3:
                        await predmet_hand.updateOznakeStatus(this.create_edit_sifra, this.selected_sifra.id).then((resp) => {
                            this.refreshSifre(resp.data.oznake_status)
                        })
                        break;
                    case 4:
                        await predmet_hand.updateSluzbenaUloga(this.create_edit_sifra, this.selected_sifra.id).then((resp) => {
                            this.refreshSifre(resp.data.oznake_status)
                        })
                        break;
                }

            } else {
                this.snackbar_pop = true;
            }
            $(".sifarnik-item").removeClass("opened-sifarnik");
        },
        // EDIT DATA SWITCH END

        // DELETE DATA SWITCH START
        deleteCode: async function () {
            let selected_id = this.selected_sifra.id
            switch (this.sifra_type) {
                case 1:
                    await predmet_hand.deletePostupak(selected_id).then((resp) => {
                        this.refreshSifre(resp.data.vrste_postupka)
                    }).catch(() => {
                        this.delete_snack_pop = true;
                    })
                    break;
                case 2:
                    await predmet_hand.deleteFaze(selected_id).then((resp) => {
                        this.refreshSifre(resp.data.faze_postupka)
                    }).catch(() => {
                        this.delete_snack_pop = true;
                    })
                    break;
                case 3:
                    await predmet_hand.deleteOznakeStatus(selected_id).then((resp) => {
                        this.refreshSifre(resp.data.oznake_status)
                    }).catch(() => {
                        this.delete_snack_pop = true;
                    })
                    break;
                case 4:
                    await predmet_hand.deleteSluzbenaUloga(selected_id).then((resp) => {
                        this.refreshSifre(resp.data.oznake_status)
                    }).catch(() => {
                        this.delete_snack_pop = true;
                    })
                    break;
            }
            $(".sifarnik-item").removeClass("opened-sifarnik");
        },
        // DELETE DATA SWITCH END

        // ADD NEW DATA START

        addCode: async function () {
            let is_valid = this.validateName();
            if (is_valid) {
                switch (this.sifra_type) {
                    case 1:
                        await predmet_hand.addNewPostupak(this.create_edit_sifra).then((resp) => {
                            this.refreshSifre(resp.data.vrste_postupka)
                        })
                        break;
                    case 2:
                        await predmet_hand.addNewFaza(this.create_edit_sifra).then((resp) => {
                            this.refreshSifre(resp.data.faze_postupka)
                        })
                        break;
                    case 3:
                        await predmet_hand.addOznakeStatus(this.create_edit_sifra).then((resp) => {
                            this.refreshSifre(resp.data.oznake_status)
                        })
                        break;
                    case 4:
                        await predmet_hand.addSluzbenaUloga(this.create_edit_sifra).then((resp) => {
                            this.refreshSifre(resp.data.oznake_status)
                        })
                        break;
                }

            } else {
                this.snackbar_pop = true;
                setTimeout(() => {
                    this.snackbar_pop = false
                }, 3000)
            }

        },
        // ADD NEW DATA END
    },
    async created() {

    },

    mounted() {
        // this.getData()
        this.sifra_type = this.drop_items.find((i) => i.id == 1).id;

        this.$store.state.paginacija.title = "Šifarnici"

    }

}

</script>

<style>

</style>